(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fe-product-menu"] && !Shopify.designMode) return;
  try {
    
      function menutothetop() {
        var windowTop = $(window)
          .scrollTop();
        var top = $('#product-menu-placeholder')
          .offset()
          .top;
        if(windowTop >= top) {
          $('#product-menu')
            .addClass('fixed');
        } else {
          $('#product-menu')
            .removeClass('fixed');
        }
      }
      $(function() {
        $(window)
          .scroll(menutothetop);
        menutothetop();
      });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fe-video-hero"] && !Shopify.designMode) return;
  try {
    
/**
jQuery( document ).ready(function() {
  jQuery(".video-container .button:nth-child(2)").attr('data-leadbox-popup','GChTCKp9YTmAwFmCYZAaoX');     
  jQuery(".video-container .button:nth-child(2)").attr('data-leadbox-domain','firstendurance.lpages.co');
});


	document.querySelector('.klaviyo_form_trigger').addEventListener('click', function (){
    window._klOnsite = window._klOnsite || []; window._klOnsite.push(['openForm', 'VNeStC']);
	});
**/

// Text rotation animation
document.addEventListener('DOMContentLoaded', function() {
  const captionContainer = document.getElementById('caption-container');
  if (captionContainer && captionContainer.children.length > 1) {
    // Make container visible now that JS will handle the display
    captionContainer.style.visibility = 'visible';
    
    // Get the delay from data attribute (in seconds) and convert to milliseconds
    const delaySeconds = parseFloat(captionContainer.getAttribute('data-delay') || 3);
    const delayMilliseconds = delaySeconds * 1000;
    
    setupTextRotation('#caption-container', delayMilliseconds, 500);
  }
});

function setupTextRotation(containerSelector, duration = 3000, fadeTime = 500) {
  // Get the container and all text divs inside it
  const container = document.querySelector(containerSelector);
  const textDivs = Array.from(container.children);
  let currentIndex = 0;
  
  // Hide all text divs except the first one
  textDivs.forEach((div, index) => {
    if (index !== 0) {
      div.style.opacity = 0;
      div.style.display = 'none';
    } else {
      div.style.opacity = 1;
      div.style.display = 'block';
    }
  });
  
  // Function to rotate to the next text div
  function rotateText() {
    // Fade out current text
    const currentDiv = textDivs[currentIndex];
    currentDiv.style.transition = `opacity ${fadeTime}ms`;
    currentDiv.style.opacity = 0;
    
    // Calculate next index
    const nextIndex = (currentIndex + 1) % textDivs.length;
    const nextDiv = textDivs[nextIndex];
    
    // After fade out completes, switch divs and fade in the next one
    setTimeout(() => {
      currentDiv.style.display = 'none';
      nextDiv.style.display = 'block';
      
      // Trigger reflow/repaint before starting the fade in
      void nextDiv.offsetWidth;
      
      nextDiv.style.transition = `opacity ${fadeTime}ms`;
      nextDiv.style.opacity = 1;
      
      // Update current index
      currentIndex = nextIndex;
    }, fadeTime);
  }
  
  // Set up interval to rotate text
  const intervalId = setInterval(rotateText, duration);
  
  // Return function to stop rotation if needed
  return function stopRotation() {
    clearInterval(intervalId);
  };
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
